import React, { useState } from 'react'
import { supabase } from '../lib/supabase'
import './Login.css'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [mode, setMode] = useState('signin') // signin | signup | reset

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      if (mode === 'reset') {
        const { error } = await supabase.auth.resetPasswordForEmail(email)
        if (error) throw error
        setError('✓ Reset link sent — check your email')
        setLoading(false)
        return
      }
      const fn = mode === 'signup'
        ? supabase.auth.signUp({ email, password })
        : supabase.auth.signInWithPassword({ email, password })
      const { error } = await fn
      if (error) throw error
    } catch (err) {
      setError(err.message)
    }
    setLoading(false)
  }


  return (
    <div className="login-bg">
      <div className="login-card">
        <div className="login-logo">
          <img src="/logo-symbol.png" alt="Aryanss" style={{ width:40, height:40, objectFit:'contain' }} />
          <div>
            <div className="login-logo-name">Aryanss IT Solutions</div>
            <div className="login-logo-sub">Project Tracker</div>
          </div>
        </div>

        <h1 className="login-title">
          {mode === 'signin' ? 'Welcome back' : mode === 'signup' ? 'Create account' : 'Reset password'}
        </h1>
        <p className="login-subtitle">
          {mode === 'signin' ? 'Sign in to your workspace' : mode === 'signup' ? 'Set up your team account' : 'We\'ll send you a reset link'}
        </p>

        {error && (
          <div className={`login-msg ${error.startsWith('✓') ? 'login-msg-ok' : 'login-msg-err'}`}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-field">
            <label>Email address</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@agency.com" required />
          </div>
          {mode !== 'reset' && (
            <div className="form-field">
              <label>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required minLength={6} />
            </div>
          )}
          <button type="submit" className="btn btn-primary" style={{ width:'100%', justifyContent:'center', padding:'10px' }} disabled={loading}>
            {loading ? 'Please wait…' : mode === 'signin' ? 'Sign in' : mode === 'signup' ? 'Create account' : 'Send reset link'}
          </button>
        </form>


        <div className="login-footer">
          {mode === 'signin' && <>
            <button onClick={() => { setMode('signup'); setError('') }}>Create account</button>
            <span>·</span>
            <button onClick={() => { setMode('reset'); setError('') }}>Forgot password?</button>
          </>}
          {mode !== 'signin' && (
            <button onClick={() => { setMode('signin'); setError('') }}>← Back to sign in</button>
          )}
        </div>

        <p className="login-notice">Access restricted to approved team members only.</p>
      </div>
    </div>
  )
}
